module.exports = __webpack_public_path__ + "static/img/logo.e91773b.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/home/pc/index1/logo.png
// module id = 7cCQ
// module chunks = 7